/**
 * CostSchemeInheritBanner — shown on a term whose program schema is inherited from its serie. The board is
 * read-only in that state; the "create override" button breaks inheritance so the term gets its own editable
 * copy (the actual mutation runs behind a confirm dialog owned by the orchestrator). Styled with Tailwind.
 */
import type { TFunction } from 'i18next';

interface CostSchemeInheritBannerProps {
  t: TFunction;
  onCreateOverride: () => void;
  createDisabled: boolean;
}

export function CostSchemeInheritBanner({
  t,
  onCreateOverride,
  createDisabled,
}: CostSchemeInheritBannerProps) {
  return (
    <div className="bg-phx-info-tint text-phx-text-2 text-phx-sm flex shrink-0 items-center gap-2.5 border-b border-[color-mix(in_srgb,var(--phx-info)_26%,var(--phx-border))] px-4.5 py-2">
      <span className="flex-1">{t('costScheme.inheritedBanner')}</span>
      <button
        type="button"
        onClick={onCreateOverride}
        disabled={createDisabled}
        className="rounded-phx border-phx-primary bg-phx-primary text-phx-primary-fg hover:bg-phx-primary-hover hover:border-phx-primary-hover text-phx-sm inline-flex h-6.5 cursor-pointer items-center gap-1.5 border px-2.5 font-medium transition-colors disabled:cursor-default disabled:opacity-50"
      >
        {t('costScheme.createOverride')}
      </button>
    </div>
  );
}
